import {PlanDescription} from "./plan-description/plan-description";

export class UserSubscriptionPlan {

  public title: string;
  public type: string;
  public domainCount: number;
  public totalDomainCount: number;
  public showDomainCount: number;
  public periodNumber: number;
  public periodTypeText: string;
  public periodType: string;
  public planPrice: number;
  public proratedCredit: number;
  public couponDiscount: number;
  public refundAmount: number;
  public price: number;
  public priceDiscount: number;
  public priceDiscounted: number;
  public priceWithProratedCredit: number;
  public recurring: boolean;
  public description: PlanDescription;
  public shortFeatures: any & { newPlan: string};
  public longFeatures: Array<string>;
  public services: any;
  public trialPeriodNumber: any;
  public trialPeriodType: any;
  public hostingTrialPeriodNumber: any;
  public additionalDomainPriceForNowAppsumo: any;
  public additionalDomainPrice: any;
  public additionalDomainParameterPrice: any;
  public additionalDomainChargedPrice: any;
  public additionalDomainCount: number;
  public additionalCDNPrice: any;
  public additionalCDNParameterPrice: number;
  public additionalCDNChargedPrice: any;
  public additionalCDNCount: number;
  public planAdditionalDomainCount: number;
  public planAdditionalDomainPrice: number;
  public cdnService: any;
  public hostingService: any;
  public cdnAdditionalBandwidthValue: any = null;
  public cdnAdditionalBandwidthPrice: any = null;
  public cdnBandwidthValue: any = null;
  public cdnBandwidthBaseValue: any = null;
  public cdnBandwidthPrice: any = null;
  public cdnCountValue: any = null;
  public cdnCountPrice: number = null;
  public aiAssistantService: any;
  public aiDomainCount: number;
  public aiBuilderService: any;
  public hasAddons: boolean;
  public json_desc_short: any;
  public woocommerceService: object;
  public apiResellerService: object;
  public hasDomainService: any;
  public planId: number;
  public couplePlanId: number;
  public dedicatedVMInfo: {
    zoneName: string;
    core: string;
    ram: string;
    vmZone: string;
  };
  public multiplierAddOnCount: number;
  public usedMultiplierAddOnCount: number;
  public usedMultiplierAddOnPrice: number = 0;
  public multiplierRegenCount: number;
  public usedMultiplierRegenCount: number;
  public usedMultiplierRegenPrice: number = 0;
  public hasMultiplierService: boolean;
  public hasAppsumoPrice: boolean;
  public agency_pricing_plan_id: number;
  public trialPeriodDays: number;
  public vibeService: any;
}

